// Domain configuration utility
// This file centralizes the domain configuration to avoid hardcoded localhost URLs

// Get the correct domain based on environment
export const getAppDomain = () => {
  // Check if we're in development mode
  if (process.env.NODE_ENV === 'development') {
    // In development, use localhost
    return 'http://localhost:3000';
  }
  
  // In production, use the actual app domain
  return 'https://app.acctoo.com';
};

// Get the correct domain for sharing links (always use production domain)
export const getShareDomain = () => {
  return 'https://app.acctoo.com';
};

// Get the correct domain for image proxying (use current origin in dev, production in prod)
export const getImageProxyDomain = () => {
  if (process.env.NODE_ENV === 'development') {
    // Fallback to localhost if window.location.origin is undefined
    return window.location.origin || 'http://localhost:3000';
  }
  return 'https://app.acctoo.com';
};
